export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        radio('network').subscribe(onNetworkStateChange);
        function onNetworkStateChange(up) {
            ele.classList.toggle('hidden', !up);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/networkIndicator.js